$(() => {
  $("form.edit_site input#site_preference_attributes_decline_threshold").keyup(function(){
    $("span#decline-threshold").html($(this).val());
  });  
});